import { Box, Typography } from '@mui/material';
import { getSampleById, getResultTemplateById } from 'actions/LaboratoryActions';
// @ts-ignore
import HTMLRenderer from 'react-html-renderer';
import A4 from 'PdfPages/pages/A4';
import { useEffect, useState } from 'react';
import useQuery from 'utils/getQueryParams';
import { connect } from 'react-redux';
import { IReducer } from 'Reducers/IReducer';
import { bindActionCreators } from 'redux';
import { ILaboratoryDetails } from 'Reducers/LaboratoryReducer/ILaboratoryReducer';
import { ICustomer, IMaster, IResultTemplate, ISample } from 'exactt-types/lib';
import { editorTokens } from 'pages/ResultTemplate/PersistResultTemplate/editorTokens';
import './print.css';
import QRCode from 'react-qr-code';
import moment from 'moment';
import GeneralTable from 'PdfPages/components/GeneralTable';
import { common } from 'constants/ImagesFiles';
import GeneralTable2 from 'PdfPages/components/GeneralTable2';
import GeneralPharmaTable2 from 'PdfPages/components/GeneralPharmaTable2';
import GeneralTable3 from 'PdfPages/components/GeneralTable3';

const tokensById: any = {};
editorTokens.forEach((token) => {
  tokensById[token.id] = token;
});

const TOKEN_MATCHER = /\{\{(\w*)\|(\w*)\}\}/gi;

interface SampleResultPrintProps {
  setDisableScroll: (value: boolean) => void;
  getSampleById: (laboratoryId: string, _id: string) => Promise<any>;
  getResultTemplateById: (laboratoryId: string, _id: string) => Promise<any>;
  laboratory: ILaboratoryDetails | null;
  sampleDetails: ISample | null;
}

export function _SampleResultPrintV2(props: SampleResultPrintProps) {
  const [resultTemplate, setResultTemplate] = useState<IResultTemplate | null>(null);
  const customerAddress = (props.sampleDetails?.customer as ICustomer)?.address?.[0];
  const sampleCollectionDate = (props.sampleDetails as any)?.sampleCollectionDate || props.sampleDetails?.collectionDate;

  const formatAddress = (address?: {
    line1?: string;
    line2?: string;
    city?: string;
    state?: string;
    zip?: string | number;
  }) => {
    if (!address) return 'N/A';

    const segments = [address.line1, address.line2, address.city].filter(Boolean);

    if (address.state && address.zip) {
      segments.push(`${address.state} - ${address.zip}`);
    } else if (address.state) {
      segments.push(address.state);
    } else if (address.zip) {
      segments.push(`${address.zip}`);
    }

    return segments.join(', ') || 'N/A';
  };

  let query = useQuery();
  let sampleId = query.get('id');
  let resultFormat = query.get('resultFormat');
  let printWithNABL = query.get('printWithNABL');
  let stamp = query.get('stamp');
  let hideTitle = query.get('hideTitle');

  const onFocus = async () => {
    if (sampleId) {
      await props.getSampleById(props.laboratory?.details._id || '', sampleId);
      const res = await props.getResultTemplateById(props.laboratory?.details._id || '', resultFormat as string);
      setResultTemplate(res);
      setTimeout(() => {
        // window.print();
      }, 1000 * 5);
      // setLoading(false);
    }
  };

  const tokensToHtml = (tokenizedString: any, tokensById: any) => {
    return tokenizedString.replace(TOKEN_MATCHER, (match: any, slug: any, id: any) => {
      const token = tokensById[id];
      // Ignore matches that aren't for a real token.
      if (!token) {
        return match;
      }

      if (token.id === 'logo') {
        return `<logo />`;
      }

      if (token.id === 'customerName') {
        return `<customername />`;
      }

      if (token.id === 'ulr') {
        return `<ulr />`;
      }

      if (token.id === 'sampleIdQRCode') {
        return `<qr />`;
      }

      if (token.id === 'sampleId') {
        return `<sampleid />`;
      }

      if (token.id === 'sampleLabId') {
        return `<samplelabid />`;
      }

      if (token.id === 'resultParameterTable') {
        return `<resultparametertable />`;
      }

      if (token.id === 'resultParameterTableTwo') {
        return `<resultparametertabletwo />`;
      }

      if (token.id === 'resultParameterTableThree') {
        return `<resultparametertablethree />`;
      }

      if (token.id === 'resultparameterpharmatabletwo') {
        return `<resultparameterpharmatabletwo />`;
      }

      if (token.id === 'customerAddress') {
        return `<customeraddress />`;
      }

      if (token.id === 'collectionBy') {
        return `<collectionby />`;
      }

      if (token.id === 'hod') {
        return `<hod />`;
      }

      if (token.id === 'expDateMMYY') {
        return `<expdatemmyy />`;
      }

      if (token.id === 'mfgDateMMYY') {
        return `<mfgdatemmyy />`;
      }

      if (token.id === 'reviewedBy') {
        return `<reviewedby />`;
      }

      if (token.id === 'stamp') {
        return `<stamp />`;
      }

      if (token.id === 'authorizedSignature1') {
        return `<authorizedsignature1 />`;
      }

      if (token.id === 'authorizedSignature2') {
        return `<authorizedsignature2 />`;
      }
      if (token.id === 'refNo') {
        return `<refno />`;
      }

      if (token.id === 'waterresult') {
        return `<waterresult />`;
      }

      if (
        token.id === 'labDueDate' ||
        token.id === 'dueDate' ||
        token.id === 'collectionDate' ||
        token.id === 'sampleCollectionDate' ||
        token.id === 'mfgDate' ||
        token.id === 'expDate' ||
        token.id === 'mfgDate' ||
        token.id === 'dateAndPlaceOfCollectionOfSample' ||
        token.id === 'completeDate' ||
        token.id === 'analysisDate' ||
        token.id === 'reportDate' ||
        token.id === 'expDateForFoodSample' ||
        token.id === 'dateOfDispatch'
      ) {
        if (token.id === 'collectionDate' || token.id === 'sampleCollectionDate') {
          return moment(sampleCollectionDate).format('DD/MM/YYYY');
        }
        return moment(props.sampleDetails?.[`${token.id}` as keyof ISample]).format('DD/MM/YYYY');
      }

      return props.sampleDetails?.[`${token.id}` as keyof ISample] || 'N/A';
    });
  };

  const headerText = tokensToHtml(resultTemplate?.header || '', tokensById);
  const finalHeaderText = tokensToHtml((resultTemplate as any)?.finalHeader || '', tokensById);
  const bodyText = tokensToHtml(resultTemplate?.body || '' || '', tokensById);
  const footerText = tokensToHtml(resultTemplate?.footer || '' || '', tokensById);
  const finalFooterText = tokensToHtml((resultTemplate as any)?.finalFooter || '', tokensById);
  const remarks = (props.sampleDetails as any)?.remarks;
  const statement = (props.sampleDetails as any)?.statement;


  useEffect(() => {
    props.setDisableScroll(true);
    onFocus();
    // eslint-disable-next-line
  }, []);

  const parameters: any[] = [];

  if (props.sampleDetails?.parameters) {
    (props.sampleDetails?.master as IMaster)?.parameters?.forEach((parameter) => {
      // find parameter from master list (props.sampleDetails?.master?.parameters)

      const sampleParameter = props.sampleDetails?.parameters?.find((p) => p.name === parameter.name);

      let isValidParameterForPrint;

      if (printWithNABL === 'YES' && parameter.isNABL === true) {
        isValidParameterForPrint = true;
      } else if (printWithNABL === 'NO' && parameter.isNABL === false) {
        isValidParameterForPrint = true;
      } else if (printWithNABL === 'ALL') {
        isValidParameterForPrint = true;
      } else {
        isValidParameterForPrint = false;
      }



      if (!isValidParameterForPrint) {
        return;
      }

      if (sampleParameter) {
        parameters.push({
          characteristic: parameter.name,
          results: sampleParameter?.result || '',
          unit: parameter.unit,
          requirements: parameter.requirements,
          permissibleLimit: parameter?.permissibleLimit || '-',
          method: parameter?.method,
          group: parameter?.resultGroup,
          type: parameter?.validations?.type,
        });
      }
    });
  }

  const components = {
    logo: (_props: any) => (
      <img src={props.laboratory?.details?.logo} alt="logo" style={{ width: '20mm', objectFit: 'contain' }} />
    ),
    qr: (_props: any) => (
      <div style={{ height: '45px', width: '45px', overflow: 'hidden', position: "absolute" }}>
        <QRCode
          size={10}
          style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
          value={props.sampleDetails?.sampleId as string + printWithNABL === "NO" ? "/N" : ""}
          viewBox={`0 0 256 256`}
        />
      </div>
    ),

    ulr: (_props: any) => {
      if (printWithNABL === "NO") { return "N/A" }
      return <strong>{props.sampleDetails?.ulr || 'N/A'}</strong>;
    },

    customername: (_props: any) => {
      const customer = props.sampleDetails?.customer;

      return (
        <div>
          <div>{typeof customer === 'object' ? customer?.name : customer}</div>
        </div>
      );
    },

    customeraddress: (_props: any) => (
      <div>
        <div>{formatAddress(customerAddress)}</div>

      </div>
    ),

    collectionby: (_props: any) => {
      const collectionBy = props.sampleDetails?.collectionBy;
      return (
        <div>
          <div>Collected By : {collectionBy}</div>
        </div>
      );
    },

    hod: (_props: any) => {
      const hod = props.sampleDetails?.hod as ICustomer;
      return (
        <div>
          <div>HOD :{hod?.name}</div>
        </div>
      );
    },

    reviewedby: (_props: any) => {
      const reviewedBy = props.sampleDetails?.reviewedBy as ICustomer;
      return (
        <div style={{ marginTop: 30, fontWeight: 'bold' }}>
          <div>{reviewedBy?.name}<br />Reviewed By</div>
        </div>
      );
    },

    expdatemmyy: (_props: any) => {
      const expDate = props.sampleDetails?.expDate;
      return (
        <span>{expDate ? moment(expDate).format('MM/YYYY') : 'N/A'}</span>
      );
    },

    mfgdatemmyy: (_props: any) => {
      const mfgDate = props.sampleDetails?.mfgDate;
      return (
        <span>{mfgDate ? moment(mfgDate).format('MM/YYYY') : 'N/A'}</span>
      );
    },

    stamp: (_props: any) => {
      if (stamp !== 'YES') return null;
      return (
        <div>
          <img src={props.laboratory?.details?.stampImage} width={'90mm'} alt="nabl" />
        </div>
      );
    },

    authorizedsignature1: (_props: any) => {
      const authorizedSignature1 = props.sampleDetails?.authorizedSignature1 as ICustomer;
      return (
        <div style={{ marginTop: 30, fontWeight: 'bold' }}>
          <div>{authorizedSignature1?.name}<br />Authorized Signatory</div>
        </div>
      );
    },

    sampleid: (_props: any) => {
      const sampleId = props.sampleDetails?.sampleId;
      if (printWithNABL === "NO") return `${sampleId}/N`
      return sampleId;
    },

    samplelabid: (_props: any) => {
      const sampleId = props.sampleDetails?.sampleId;
      return (sampleId || "")?.replace(`${props.laboratory?.details?.prefix}/`, "");
    },

    authorizedsignature2: (_props: any) => {
      const authorizedSignature2 = props.sampleDetails?.authorizedSignature2 as ICustomer;
      return (
        <div style={{ marginTop: 30, fontWeight: 'bold' }}>
          <div>{authorizedSignature2?.name}<br />Authorized Signatory</div>
        </div>
      );
    },

    refno: (_props: any) => {
      const refNo = props?.sampleDetails?.sampleCode || 'N/A';

      return <span>{refNo}</span>;
    },

    resultparametertable: (_props: any) => {
      return (
        <div className="print-table-with-border">
          <GeneralTable fields={parameters} />
        </div>
      );
    },

    resultparametertabletwo: (_props: any) => {
      return (
        <div className="print-table-with-border">
          <GeneralTable2 fields={parameters} />
        </div>
      );
    },

    resultparametertablethree: (_props: any) => {
      return (
        <div className="print-table-with-border">
          <GeneralTable3 fields={parameters} />
        </div>
      );
    },

    waterresult: (_props: any) => {
      return (
        <div className="print-table-with-border">
          <GeneralTable3 fields={parameters} />
        </div>
      );
    },

    resultparameterpharmatabletwo: (_props: any) => {
      return (
        <div className="print-table-with-border">
          <GeneralPharmaTable2 sample={props.sampleDetails} fields={parameters} />
        </div>
      );
    },
  };

  return (
    <Box className="print">
      <A4
        header={
          <>
            <Box mt={0} display={'flex'} flexDirection={'column'} justifyContent={'center'} alignItems={'center'}>
              {printWithNABL === 'YES' ? (
                <div>
                  <img src={common.nablLogo} width={'60mm'} alt="nabl" />
                </div>
              ) : <div style={{ height: "60px" }} />}
              {printWithNABL === 'YES' ? (
                <Box mb={1} mt={-0.5}>
                  <Typography fontSize={12} fontWeight={'600'}>
                    {props.laboratory?.details?.nabl}
                  </Typography>
                </Box>
              ) : <div style={{
                height: "10mm"
              }} />}
              { }
              {props.laboratory?.details?.labType !== 'PHARMA' ? hideTitle === "YES" ? <></> : (
                <Typography fontSize={16} fontWeight={'bold'}>
                  TEST REPORT
                </Typography>
              ) : (
                <>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      paddingBottom: '1px',
                      borderBottom: '1px solid black',
                    }}
                  >
                    <Typography
                      fontSize={16}
                      fontWeight={'bold'}
                      style={{
                        textDecoration: 'underline',
                        marginBottom: '10px',
                        fontFamily: 'Arial',
                      }}
                    >
                      Certificate of Analysis
                    </Typography>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      textAlign: 'right',
                      marginTop: '-30px',
                      fontFamily: 'Arial',
                    }}
                  >
                    Analytical Lic No. : GTL/37/40
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      marginTop: '13px',
                      justifyContent: 'center',
                      alignItems: 'center',
                      paddingBottom: '15px',
                      borderBottom: '1px solid black',
                    }}
                  >
                    <Typography
                      fontSize={16}
                      fontWeight={'bold'}
                      style={{
                        textDecoration: 'underline',
                        marginBottom: '10px',
                        fontFamily: 'Arial',
                      }}
                    >
                      Form - 39
                    </Typography>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      textAlign: 'center',
                      marginTop: '-20px',
                      fontWeight: 'bold',
                    }}
                  >
                    (150 - E (f) Report of the test or analysis by Approved Institution)
                  </div>
                </>
              )}
            </Box>
            <HTMLRenderer html={headerText} components={components} />
          </>
        }
        finalHeader={<HTMLRenderer html={finalHeaderText} components={components} />}
        body={
          <>
            <HTMLRenderer html={bodyText} components={components} />
            {(remarks || statement) && (
              <Box mt={2}>
                <table
                  style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    fontFamily: 'Arial',
                    fontSize: 14,
                  }}
                >
                  <tbody>
                    {remarks ? (
                      <tr>
                        <td style={{ width: '25%', border: '1px solid black', padding: '6px', fontWeight: 'bold' }}>
                          Remarks
                        </td>
                        <td style={{ border: '1px solid black', padding: '6px' }}>{remarks}</td>
                      </tr>
                    ) : null}
                    {statement ? (
                      <tr>
                        <td style={{ width: '25%', border: '1px solid black', padding: '6px', fontWeight: 'bold' }}>
                          Statement
                        </td>
                        <td style={{ border: '1px solid black', padding: '6px' }}>{statement}</td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
              </Box>
            )}
          </>
        }
        footer={<HTMLRenderer html={footerText} components={components} />}
        finalFooter={<HTMLRenderer html={finalFooterText} components={components} />}
      />
      <div style={{ display: "flex", justifyContent: "center", fontSize: 10 }}>
        ............................................................................................End of Report...........................................................................................
      </div>
    </Box>
  );
}

const mapStateToProps = (state: IReducer) => ({
  laboratory: state.laboratory.current,
  sampleDetails: state.laboratory.sampleDetails,
});

function mapDispatchToProps(dispatch: any) {
  return {
    ...bindActionCreators(
      {
        getSampleById,
        getResultTemplateById,
      },
      dispatch
    ),
  };
}

export const SampleResultPrintV2 = connect(mapStateToProps, mapDispatchToProps)(_SampleResultPrintV2);
